module.exports = __webpack_public_path__ + "media/ding-sound.eefa7963.mp3";